var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6668 24.5002L23.6668 17.0002L13.6668 9.50016V24.5002ZM17.0002 0.333496C7.80016 0.333496 0.333496 7.80016 0.333496 17.0002C0.333496 26.2002 7.80016 33.6668 17.0002 33.6668C26.2002 33.6668 33.6668 26.2002 33.6668 17.0002C33.6668 7.80016 26.2002 0.333496 17.0002 0.333496ZM17.0002 30.3335C9.65016 30.3335 3.66683 24.3502 3.66683 17.0002C3.66683 9.65016 9.65016 3.66683 17.0002 3.66683C24.3502 3.66683 30.3335 9.65016 30.3335 17.0002C30.3335 24.3502 24.3502 30.3335 17.0002 30.3335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayVideo);
export default __webpack_public_path__ + "static/media/iconPlayVideo.d1efca232f0cb0229315350bf0737ae6.svg";
export { ForwardRef as ReactComponent };